import React from 'react';
import { useTranslation } from 'react-i18next';
import { get, set, sequence } from '@totalsoft/change-tracking-react';
import { Checkbox, FormControlLabel, Grid, FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import Typography from '@mui/material/Typography';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const PeriodsComponent = ({ periodsLens, validationPeriods, readOnly }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography fontWeight='bold'>{t('Offer.Edit.InsuranceData.Period')}</Typography>
      </Grid>
      {(periodsLens |> sequence).map((period, index) => {
        return (
          <Grid item xs={12} sm={4} md={3} lg={2} key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  id={'InsuranceData_Period_' + index}
                  checked={Boolean(period.selected |> get)}
                  disabled={readOnly}
                  onChange={period.selected |> set |> onCheckBoxChange}
                />
              }
              label={period.id |> get}
            />
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <FormHelperText error={!isValid(validationPeriods)}>{getErrors(validationPeriods)}</FormHelperText>
      </Grid>
    </Grid>
  );
};
PeriodsComponent.propTypes = {
  periodsLens: PropTypes.object.isRequired,
  validationPeriods: PropTypes.object,
  readOnly: PropTypes.bool.isRequired
};
export default PeriodsComponent;
